import { useDocumentTitle as _useDocumentTitle } from "./useDocumentTitle";
import { useMediaQuery as _useMediaQuery } from "./useMediaQuery";
import { useTimer as _useTimer } from "./useTimer";

export const useDocumentTitle = _useDocumentTitle;
export const useMediaQuery = _useMediaQuery;
export const useTimer = _useTimer;
